module.exports = __webpack_public_path__ + "static/media/pricing-notes.ab4fb1ff.svg";